<template>
    <div v-if="tournament">
        <div class="tournament__detail__bottom">
            <div class="tournament__detail__bottom__content float-content">
                <div class="bottom__left fl" @click="likeFunc">
                    <span class="favorite-icon" :class="favoriteStatus ? 'active' : ''"></span>
                </div>
                <div class="bottom__right fr">
                    <div class="bottom__right__content float-content">
                        <p class="tournament-fee fl">{{numberFormat(tournament.entryFee)}}원</p>
                        <div class="participation-btn fl"
                             :class="!tournament.applyAllowed || tournamentState(tournament) !== 1 || tournament.tnmtType != 1? 'disabled' : ''"

                             @click="tournamentParticipation">참가하기
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <ConfirmModal title="알림" content="로그인이 필요한 기능입니다. 로그인하시겠습니까?" v-if="locationConfirmShow" @close="locationConfirmShow=false" @ok="$router.push('/login')"></ConfirmModal>
        <AlertModal title="알림" content="참가할수 없는 대회입니다" v-if="UnableParticipantAlertShow" @close="UnableParticipantAlertShow=false"></AlertModal>

        <div class="default-bottom-wrap ">
            <div class="bottom-wrap">
                <div class="bottom" :class="$route.name==='TournamentList' || $route.name==='GymList'? 'active' : ''">
                    <router-link to="/">
                        <div class="bottom-icon home"></div>
                    </router-link>
                </div>

                <div class="bottom" :class="$route.name==='SearchPage' ? 'active' : ''">
                    <router-link to="/search">
                        <div class="bottom-icon search"></div>
                    </router-link>
                </div>


                <div class="bottom" :class="$route.name==='MyPage' ? 'active' : ''">
                    <router-link to="/mypage">
                        <div class="bottom-icon mypage"></div>
                    </router-link>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    import {mapState} from 'vuex';
    import ConfirmModal from "../modal/ConfirmModal";
    import AlertModal from "../modal/AlertModal";
    export default {
        components: {AlertModal, ConfirmModal},
        computed: {
            ...mapState('tournaments', ['tournament']),
            ...mapState('me', ['me'])
        },
        data(){
            return{
                favoriteStatus: null,
                locationConfirmShow:false,
                UnableParticipantAlertShow:false
            }
        },
        methods: {
            tournamentParticipation() {
                if (this.tournament.applyAllowed && this.tournamentState(this.tournament)) {
                    this.$router.push(`/tournament/participation/${this.tournament.tnmtId}`)
                }else{
                 this.UnableParticipantAlertShow = true
                }

            },
            likeFunc() {
                const _this = this;
                if(!localStorage.getItem('access_token')){
                    this.locationConfirmShow = true
                }else{
                    this.$store.dispatch('me/getMe').then((res) => {
                        const temp = {
                            itemId: _this.tournament.tnmtId,
                            userId: res.userId,
                            itemType: 'TNMT'
                        }
                        _this.$store.dispatch('favorites/updateFavorite', temp).then(res => {
                            _this.likeCheck();
                        }).catch(() => {

                        })
                    }).catch(() => {

                        _this.locationConfirmShow = true
                    })
                }



            },
            likeCheck() {

                const _this = this;
                if(!localStorage.getItem('access_token')){
                    _this.favoriteStatus = false
                }else{
                    this.$store.dispatch('me/getMe').then((res) => {

                        const temp = {
                            itemId: _this.tournament.tnmtId,
                            userId: res.userId,
                            itemType: 'TNMT'
                        }
                        this.$store.dispatch('favorites/checkFavorite', temp).then(res => {
                            _this.favoriteStatus = res.favoriteStatus
                        }).catch(err => {
                            console.dir(err);
                        })
                    }).catch(err => {

                        _this.locationConfirmShow = true
                    })
                }

            },
        },
        mounted() {
            if(this.user){
                this.likeCheck()
            }

        }
    }
</script>
